import { Component } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
    selector: 'formly-wrapper-simple-panel',
    template: `
    <ng-container #fieldComponent></ng-container>
  `,
})
export class FormlyWrapperSimplePanel extends FieldWrapper { }
